var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchInCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F7F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3701 24.7278C43.2753 28.633 43.2753 34.9647 39.3701 38.8699C35.4648 42.7751 29.1332 42.7751 25.2279 38.8699C21.3227 34.9647 21.3227 28.633 25.2279 24.7278C29.1332 20.8225 35.4648 20.8225 39.3701 24.7278ZM43.5124 40.1839C47.6237 34.7002 47.1857 26.8865 42.1985 21.8993C36.7311 16.432 27.8668 16.432 22.3995 21.8993C16.9322 27.3667 16.9322 36.231 22.3995 41.6983C27.3867 46.6855 35.2004 47.1235 40.684 43.0123L50.6838 53.012L53.5122 50.1836L43.5124 40.1839Z",
    fill: "#A2A4B0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInCircle);
export default __webpack_public_path__ + "static/media/search-in-circle.f2c9b6b291f42fcf91c7ae569486b006.svg";
export { ForwardRef as ReactComponent };